// LIST
export const FETCH_FAQS = "app/Faqs/FETCH_FAQS";
export const FETCH_FAQS_SUCCESS = "app/Faqs/FETCH_FAQS_SUCCESS";
export const FETCH_FAQS_FAILURE = "app/Faqs/FETCH_FAQS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Faqs/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Faqs/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Faqs/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_FAQS = "app/Faqs/ADD_FAQS";
export const ADD_FAQS_SUCCESS = "app/Faqs/ADD_FAQS_SUCCESS";
export const ADD_FAQS_FAILURE = "app/Faqs/ADD_FAQS_FAILURE";
// EDIT
export const EDIT_FAQS = "app/Faqs/EDIT_FAQS";
export const EDIT_FAQS_SUCCESS = "app/Faqs/EDIT_FAQS_SUCCESS";
export const EDIT_FAQS_FAILURE = "app/Faqs/EDIT_FAQS_FAILURE";
// DELETE
export const DELETE_FAQS = "app/Faqs/DELETE_FAQS";
export const DELETE_FAQS_SUCCESS = "app/Faqs/DELETE_FAQS_SUCCESS";
export const DELETE_FAQS_FAILURE = "app/Faqs/DELETE_FAQS_FAILURE";
